import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { maxPassengerCount, minPassengerCount } from 'entities/umrah/types'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  pilgrimsCount: number
}

export const UmraPilgrimsCount = ({ pilgrimsCount }: Props) => {
  const { t } = useTranslation()

  return (
    <Paper
      className={s.container}
      padding={[12, 16, 12, 16]}
    >
      <div className={s.info}>
        <p className={clsx('bold-16', s.title)}>
          {t('umrah_block.pilgrims_count_text')}
        </p>
        <p className={clsx('medium-14', s.subtitle)}>
          {t('umrah_block.from_to', {
            from: minPassengerCount,
            to: maxPassengerCount,
          })}
        </p>
      </div>

      <p className={clsx('bold-16', s.count)}>{pilgrimsCount}</p>
    </Paper>
  )
}
